import { render } from "./App.vue?vue&type=template&id=a84241be"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=a84241be&lang=css"
import "./App.vue?vue&type=style&index=1&id=a84241be&lang=css"

import exportComponent from "D:\\repos\\guanceshu\\guanceshu\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__